export enum Sync {
  No = 0,
  Yes
}
